import { render, staticRenderFns } from "./AppFab.vue?vue&type=template&id=373ad106&scoped=true&"
import script from "./AppFab.vue?vue&type=script&lang=js&"
export * from "./AppFab.vue?vue&type=script&lang=js&"
import style0 from "./AppFab.vue?vue&type=style&index=0&id=373ad106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ad106",
  null
  
)

export default component.exports